import { useCallback } from "react";

const PRIVACY_POLICY_URL = "https://privacy.megazone.com/production/mzc/privacy/index.html";
// 이용약관 페이지가 없는 언어는 영문 페이지로 연결한다
const TERMS_EN_FALLBACK_LANGUAGES = ["zh", "pt-BR"];

/**
 * 개인정보처리방침·이용약관 페이지를 새 창으로 여는 공용 훅.
 * 프로필 메뉴와 welcome 페이지 Footer가 같은 URL 규칙을 쓰도록 한곳에 둔다. (DAM-973)
 *
 * @param {string} i18nLng 현재 언어 코드 (이용약관 언어별 링크 산출용)
 * @returns {{ openTermsPrivacy: Function, openTermsService: Function }}
 */
const useTermsLinks = (i18nLng) => {
    // 통합 개인정보처리방침은 한글 단일 페이지라 언어와 무관하게 연결한다 (DAM-939)
    const openTermsPrivacy = useCallback(() => {
        window.open(PRIVACY_POLICY_URL);
    }, []);

    const openTermsService = useCallback(() => {
        const termsLng = TERMS_EN_FALLBACK_LANGUAGES.includes(i18nLng) ? "en" : i18nLng;
        const url = `https://cloudplex.megazone.com/${termsLng !== "ko" ? `${termsLng}/` : ""}terms/latest`;
        window.open(url);
    }, [i18nLng]);

    return { openTermsPrivacy, openTermsService };
};

export default useTermsLinks;
